/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalEmrType } from './ExternalEmrType';
import {
    ExternalEmrTypeFromJSON,
    ExternalEmrTypeFromJSONTyped,
    ExternalEmrTypeToJSON,
} from './ExternalEmrType';

/**
 * 
 * @export
 * @interface ExternalEmrDocument
 */
export interface ExternalEmrDocument {
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    id: string;
    /**
     * 
     * @type {ExternalEmrType}
     * @memberof ExternalEmrDocument
     */
    type: ExternalEmrType;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    external_document_id: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    document_type: ExternalEmrDocumentDocumentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    document_type_display_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    discipline?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    status?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalEmrDocument
     */
    is_esigned?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalEmrDocument
     */
    is_finalized?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalEmrDocument
     */
    is_active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalEmrDocument
     */
    has_change_history?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    key_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    start_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    end_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    completed_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    last_signed_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    external_facility_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    s3_key?: string | null;
    /**
     * Signed URL, injected at read time and valid for one hour
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    s3_access_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    content_type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExternalEmrDocument
     */
    filesize_in_bytes?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExternalEmrDocument
     */
    page_count?: number | null;
    /**
     * Net Health lists the document but cannot produce the file, so it is shown for reference only: there is no s3_key and it cannot be included in a package.
     * @type {boolean}
     * @memberof ExternalEmrDocument
     */
    is_render_unavailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExternalEmrDocument
     */
    date_created?: string;
}


/**
 * @export
 */
export const ExternalEmrDocumentDocumentTypeEnum = {
    Eval: 'EVAL',
    Recert: 'RECERT',
    Pr: 'PR',
    Note: 'NOTE',
    Ten: 'TEN',
    Disch: 'DISCH'
} as const;
export type ExternalEmrDocumentDocumentTypeEnum = typeof ExternalEmrDocumentDocumentTypeEnum[keyof typeof ExternalEmrDocumentDocumentTypeEnum];


/**
 * Check if a given object implements the ExternalEmrDocument interface.
 */
export function instanceOfExternalEmrDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "external_document_id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "document_type" in value;

    return isInstance;
}

export function ExternalEmrDocumentFromJSON(json: any): ExternalEmrDocument {
    return ExternalEmrDocumentFromJSONTyped(json, false);
}

export function ExternalEmrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEmrDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ExternalEmrTypeFromJSON(json['type']),
        'external_document_id': json['external_document_id'],
        'name': json['name'],
        'document_type': json['document_type'],
        'document_type_display_name': !exists(json, 'document_type_display_name') ? undefined : json['document_type_display_name'],
        'discipline': !exists(json, 'discipline') ? undefined : json['discipline'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'is_esigned': !exists(json, 'is_esigned') ? undefined : json['is_esigned'],
        'is_finalized': !exists(json, 'is_finalized') ? undefined : json['is_finalized'],
        'is_active': !exists(json, 'is_active') ? undefined : json['is_active'],
        'has_change_history': !exists(json, 'has_change_history') ? undefined : json['has_change_history'],
        'key_date': !exists(json, 'key_date') ? undefined : json['key_date'],
        'start_date': !exists(json, 'start_date') ? undefined : json['start_date'],
        'end_date': !exists(json, 'end_date') ? undefined : json['end_date'],
        'completed_date': !exists(json, 'completed_date') ? undefined : json['completed_date'],
        'last_signed_date': !exists(json, 'last_signed_date') ? undefined : json['last_signed_date'],
        'external_facility_name': !exists(json, 'external_facility_name') ? undefined : json['external_facility_name'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        's3_access_url': !exists(json, 's3_access_url') ? undefined : json['s3_access_url'],
        'content_type': !exists(json, 'content_type') ? undefined : json['content_type'],
        'filesize_in_bytes': !exists(json, 'filesize_in_bytes') ? undefined : json['filesize_in_bytes'],
        'page_count': !exists(json, 'page_count') ? undefined : json['page_count'],
        'is_render_unavailable': !exists(json, 'is_render_unavailable') ? undefined : json['is_render_unavailable'],
        'date_created': !exists(json, 'date_created') ? undefined : json['date_created'],
    };
}

export function ExternalEmrDocumentToJSON(value?: ExternalEmrDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ExternalEmrTypeToJSON(value.type),
        'external_document_id': value.external_document_id,
        'name': value.name,
        'document_type': value.document_type,
        'document_type_display_name': value.document_type_display_name,
        'discipline': value.discipline,
        'status': value.status,
        'is_esigned': value.is_esigned,
        'is_finalized': value.is_finalized,
        'is_active': value.is_active,
        'has_change_history': value.has_change_history,
        'key_date': value.key_date,
        'start_date': value.start_date,
        'end_date': value.end_date,
        'completed_date': value.completed_date,
        'last_signed_date': value.last_signed_date,
        'external_facility_name': value.external_facility_name,
        's3_key': value.s3_key,
        's3_access_url': value.s3_access_url,
        'content_type': value.content_type,
        'filesize_in_bytes': value.filesize_in_bytes,
        'page_count': value.page_count,
        'is_render_unavailable': value.is_render_unavailable,
        'date_created': value.date_created,
    };
}

